import {
  BLOG_STATE_ACTIVE,
  BLOG_STATE_DRAFT,
  BLOGS_ITEMS_PER_PAGE,
  TAGS_ITEMS_PER_PAGE
} from "../../../pages/blogs/constants";
import apiService from "./apiService";


export const postOrPutBlogTags = (id, data) => {
  return id ? putBlogTags(id, data) : postBlogTags(data);
};
export const putBlogTags = (id, data) => {
  return apiService.put(URIS_D('blog_tag', id), data);
};
export const deleteBlogTags = (id) => {
  return apiService.delete(URIS_D('blog_tag', id));
};
export const postBlogTags = (data) => {
  return apiService.post(URIS.blog_tags, data);
};

export const getSearchedTags = ({searchText} = {}) => {
  const params = {
    title: searchText
  };
  return apiService.get(URIS.blog_tags, {params});
};
export const getAllTags = (page = 1) => {
  let params = {
    page,
    item_per_page: TAGS_ITEMS_PER_PAGE,
  };
  return apiService.get(URIS.blog_tags, {params});
};

export const postOrPatchBlogs = (id, data) => {
  console.log(data)
  return id ? patchBlogs(id, data) : postBlogs(data);
};

export const postBlogs = ( data) => {
  return apiService.post(URIS.blogs, data);
};

export const patchBlogs = (id, data) => {
  return apiService.patch(URIS_D('blog', id), data);
};

export const getBlog = (id,) => {
  return apiService.get(URIS_D('blog', id));
};

export const getAllBlogs = (page = 1, state) => {
  let params = {
    page,
    item_per_page: BLOGS_ITEMS_PER_PAGE,
    ...(state && {state})
  };
  return apiService.get(URIS.blogs, {params});
};
export const getSearchBlogs = ({searchText="", state=BLOG_STATE_ACTIVE}) => {
  let params = {
    title: searchText,
    ...(state && {state})
  };
  return apiService.get(URIS.blogs, {params});
};


const URIS_D = (url, param1, param2) => {
  return {
    blog_tag: `/v1/cms/blog_tags/${param1}`,
    blog: `/v1/cms/blogs/${param1}`,
  }[url];
};

const URIS = {
  blogs: '/v1/cms/blogs',
  blog_tags: '/v1/cms/blog_tags'
};
